// extracted by mini-css-extract-plugin
export var optionGrid = "_ag-7";
export var optionList = "_ag-6";
export var questionsBlock = "_ag-9";
export var spacer = "_ag-5";
export var stepCenteredContent = "_ag-3";
export var stepInner = "_ag-0";
export var stepInnerFullWidth = "_ag-1";
export var stepInnerLockScroll = "_ag-2";
export var stepTransitionFrame = "_ag-4";
export var welcomeBlock = "_ag-8";